import { ReactElement } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  DropdownWrapper,
  EditableDropdown,
  Input,
  PageWrapper
} from '../../../../../components'
import strings from '../../../../../locale/en'
import { RootState } from '../../../../../redux/store'
import { updateStudentInformation } from '../../../../../redux/userDetail/actions'
import { stateList, countryList } from './const'
import { FlexWrapper, InfoWrapper } from './subcomponents'

const CommunicationDetails = (): ReactElement => {
  const {
    studentInformation: {
      address,
      parentNumber,
      district,
      taluk,
      city,
      zipCode,
      email
    }
  } = useSelector(
    (state: RootState) => ({
      studentInformation: state.userDetail.studentInformation
    }),
    shallowEqual
  )
  const dispatch = useDispatch()

  const {
    studentDetails: {
      addressLabel,
      addressPlaceholder,
      parentMobileNumberLabel,
      parentMobileNumberPlaceholder,
      emailLabel,
      emailPlaceholder,
      stateLabel,
      statePlaceholder,
      districtLabel,
      districtPlaceholder,
      talukLabel,
      talukPlaceholder,
      cityLabel,
      cityPlaceholder,
      countryLabel,
      countryPlaceholder,
      postalLabel,
      postalPlaceholder
    }
  } = strings
 
  return (
    <PageWrapper>
      <InfoWrapper>
        <FlexWrapper width="100%">
          <DropdownWrapper>
            <Input
              label={addressLabel}
              isRequired
              placeholder={addressPlaceholder}
              value={address || ''}
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ address: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={parentMobileNumberLabel}
              isRequired
              placeholder={parentMobileNumberPlaceholder}
              value={parentNumber || ''}
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ parentNumber: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={emailLabel}
              isRequired
              placeholder={emailPlaceholder}
              value={email || ''}
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ email: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>

          <DropdownWrapper>
            <EditableDropdown
              dropdownList={stateList}
              isRequired
              title={stateLabel}
              placeholder={statePlaceholder}
              onBlur={() => { }}
              error={''}
              handleSelect={({ name }) =>
                dispatch(updateStudentInformation({ state: name }))
              }
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={districtLabel}
              isRequired
              placeholder={districtPlaceholder}
              value={district || ''}
              onBlur={() => { }}
              error={''}
              width="100%"
              onChange={(value) => {
                dispatch(updateStudentInformation({ district: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={talukLabel}
              isRequired
              placeholder={talukPlaceholder}
              value={taluk || ''}
              onBlur={() => { }}
              error={''}
              width="100%"
              onChange={(value) => {
                dispatch(updateStudentInformation({ taluk: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={cityLabel}
              isRequired
              placeholder={cityPlaceholder}
              value={city || ''}
              onBlur={() => { }}
              error={''}
              width="100%"
              onChange={(value) => {
                dispatch(updateStudentInformation({ city: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={countryList}
              isRequired
              title={countryLabel}
              placeholder={countryPlaceholder}
              handleSelect={({ name }) =>
                dispatch(updateStudentInformation({ country: name }))
              }
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={postalLabel}
              placeholder={postalPlaceholder}
              value={zipCode || ''}
              isRequired
              onBlur={() => { }}
              error={''}
              width="100%"
              onChange={(value) => {
                dispatch(updateStudentInformation({ zipCode: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
        </FlexWrapper>
      </InfoWrapper>
    </PageWrapper>
  )
}

export default CommunicationDetails
